import React, { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// Component
import ContactUs from './ContactUs';

import {
  handle_activePage,
} from '../../Redux/reducer';

//Slider or Carousel
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import SwiperCore, {
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Autoplay,
    EffectCube,
  } from "swiper";

// Illustrations
import IntroImg from '../../assets/connect from anywhere.svg';
import Slide1 from '../../assets/video conferencing 1.jpg';
import Slide2 from '../../assets/video conferencing 2.jpg';
import Slide3 from '../../assets/cafe conversation.svg';
import Slide4 from '../../assets/virtual chat.svg';
import member1 from '../../assets/member1.jpg';
import Amrita_TBI_logo from '../../assets/Amrita_TBI_logo.jpg';

import gtag from 'ga-gtag'

const Home = () => {
    
  //Google Analytics event
  gtag('event','Entered_home_page')

  SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectCube]);
  const dispatch = useDispatch();
  const [showTeam,setShowTeam] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  // console.log("Home:isAuthenticated,user = ",isAuthenticated,user);

  function reveal() {
    var reveals = document.querySelectorAll(".reveal");
  
    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = reveals[i].getBoundingClientRect().top;
      var elementVisible = 150;
  
      if (elementTop < windowHeight 
        - elementVisible
        ) {
        reveals[i].classList.add("active-section");
      } else {
        reveals[i].classList.remove("active-section");
      }
    }
  }

  window.addEventListener("scroll", reveal);

  return (
    <div className="home-page">
      <div className='home-intro-section'>
        <div className='home-intro-first'>
          <img src={IntroImg} className='home-intro-image active-section fade-left'/>
        </div>
        <div className='home-intro-second'>
          <div className='home-intro-text active-section fade-right'>
            {/* The New Dimension <br /> in Connectivity */}
            See, Feel <br/> and Talk!
          </div>
        </div>
      </div>
      <div className='home-why-section'>
        <div className='home-why-first'>
          <div className='home-why-text reveal fade-top'>
            WHY
          </div>
        </div>
        <div className='home-why-second'>
          <div className="home-why-slider">
            <Swiper
              slidesPerView={1}
              loop={true}
              autoplay={{ delay: 4000 }}
              className="slides"
            >
                <SwiperSlide>
                    <div className='home-why-slide-image-container'>
                      <img src={Slide1} className='home-why-slide-image' alt='SlideImage'/>
                    </div> 
                    <div className='home-why-slide-text'>
                      Boundaryless organization level communication and collaboration.
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                        <div className='home-why-slide-image-container'>
                          <img src={Slide2} className='home-why-slide-image' alt='SlideImage'/>
                        </div>
                        <div className='home-why-slide-text'>
                          Uninterrupted communication even in poor bandwidth conditions.
                        </div>
                </SwiperSlide>
                <SwiperSlide>
                        <div className='home-why-slide-image-container'>
                            <img src={Slide3} className='home-why-slide-image' style={{width:"100%"}} alt='SlideImage'/>
                        </div>
                        <div className='home-why-slide-text'>
                          Casual conversation over a coffee.
                        </div>
                </SwiperSlide>
                <SwiperSlide>
                        <div className='home-why-slide-image-container'>
                            <img src={Slide4} className='home-why-slide-image' style={{width:"100%"}} alt='SlideImage'/>
                        </div>
                        <div className='home-why-slide-text'>
                          Near real-life experience to the communication bring people closer.
                        </div>
                </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
      <div className='home-product-section'>
        <div className='home-product-title'>
          Our Products
        </div>
        <div className='home-product-container reveal fade-bottom'>
          <Link to='/hi' className='home-product-hi' onClick={()=>dispatch(handle_activePage("hi"))}>
            <div className='home-product-hi-logo'></div>
            <div className='home-product-hi-text'>
              Bring the mojo back into meetings.
            </div>
            <div to='/hi' className='viewMore'>View more</div> 
          </Link>
          <Link to='/hiLite' className='home-product-hiLite' onClick={()=>dispatch(handle_activePage("hiLite"))}>
            <div className='home-product-hiLite-logo'></div>
            <div className='home-product-hiLite-text'>
              Missing chai talks @ work?
            </div>
            <div to='/hiLite' className='viewMore'>View more</div>
          </Link>
          <Link to='/hiRender' className='home-product-hiRender' onClick={()=>dispatch(handle_activePage("hiRender"))}>
            <div className='home-product-hiRender-logo'></div>
            <div className='home-product-hiRender-text'>
              Enter the whole new world of realism.
            </div>
            <div className='viewMore'>View more</div>
          </Link>
        </div>
      </div>
      {showTeam ?
      <div className='home-team-section'>
        <div className='home-team-title'>
          Meet Our Team
        </div>
        <div className='home-team-container'>
          <div class='home-team-wrapper'>
            <div class='home-team-carousel'>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                    This is some description about the member. 
                    This is some description about the member. 
                    This is some description about the member. 
                  </p>
                </div>
              </div>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                    This is some description about the member. 
                  </p>
                </div>
              </div>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                  </p>
                </div>
              </div>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                  </p>
                </div>
              </div>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                  </p>
                </div>
              </div>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                  </p>
                </div>
              </div>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                  </p>
                </div>
              </div>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                  </p>
                </div>
              </div>
              <div class='home-team-carousel_item'>
                <div class='home-team-carousel_item-head'>
                  <img src={member1} className='home-team-member-image'/>
                </div>
                <div class='home-team-carousel_item-body'>
                  <p class='home-team-item-body-title'>Member Name</p>
                  <p class='home-team-item-body-role'>Designation</p>
                  <p class='home-team-item-body-description'>
                    This is some description about the member. 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      : <></>}
      <div id='contact' style={{position:'relative', top:"-75px"}} />
      <ContactUs />
      <div className='home-support-section'>
        <div className='home-support-title'>
          Supported By AMRITA TBI NIDHI-PRAYAS
        </div>
        <div className='home-support-brand-logo'>
          <a href="https://www.amritatbi.com/prayas.html" target="_blank">
            <img src={Amrita_TBI_logo} alt="Amrita TBI logo" width="300" height="100" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;